<div class="modal-content translate-modal">
  <div class="modal-header">
    <h3 class="modal-title pull-left" id="my-modal-title">
      {{ "TRANSLATE" | globalTranslate }}
    </h3>
  </div>
  <div class="modal-body">
    <div class="language-grid">
      <div class="language-column">
        @for (lang of getFirstColumnLanguages(); track lang) {
        <a
          class="language-link"
          [attr.tabindex]="0"
          [class.active]="selectedGlobalLang === lang.LanguageCode"
          (click)="selectedGlobalLang = lang.LanguageCode; translateToGlobal()"
        >
          {{ lang.LanguageName }}
        </a>
        }
      </div>
      <div class="language-column">
        @for (lang of getSecondColumnLanguages(); track lang) {
        <a
          class="language-link"
          [attr.tabindex]="0"
          [class.active]="selectedGlobalLang === lang.LanguageCode"
          (click)="selectedGlobalLang = lang.LanguageCode; translateToGlobal()"
        >
          {{ lang.LanguageName }}
        </a>
        }
      </div>
    </div>
    <p
      class="aws-note"
      [innerHTML]="'AWS_TRANSLATE_NOTE' | globalTranslate"
    ></p>
  </div>
  <div class="modal-footer d-block">
    <div class="action-container">
      <button
        type="button"
        id="dialog"
        class="btn btn-block btn-secondary btn-start"
        (click)="onCancel()"
      >
        {{ "CLOSE" | globalTranslate }}
      </button>
    </div>
  </div>
</div>